//
// This file has been generated by [index-modules](https://npmjs.com/index-modules)
//

const properties = {}

import _acl, * as __acl from "./acl"
properties.acl = { enumerable: true, get: () => _acl }
export { __acl as acl }

import _backup, * as __backup from "./backup"
properties.backup = { enumerable: true, get: () => _backup }
export { __backup as backup }

import _disk, * as __disk from "./disk"
properties.disk = { enumerable: true, get: () => _disk }
export { __disk as disk }

import _docker, * as __docker from "./docker"
properties.docker = { enumerable: true, get: () => _docker }
export { __docker as docker }

import _group, * as __group from "./group"
properties.group = { enumerable: true, get: () => _group }
export { __group as group }

import _host, * as __host from "./host"
properties.host = { enumerable: true, get: () => _host }
export { __host as host }

import _ipPool, * as __ipPool from "./ip-pool"
properties.ipPool = { enumerable: true, get: () => _ipPool }
export { __ipPool as ipPool }

import _job, * as __job from "./job"
properties.job = { enumerable: true, get: () => _job }
export { __job as job }

import _log, * as __log from "./log"
properties.log = { enumerable: true, get: () => _log }
export { __log as log }

import _message, * as __message from "./message"
properties.message = { enumerable: true, get: () => _message }
export { __message as message }

import _network, * as __network from "./network"
properties.network = { enumerable: true, get: () => _network }
export { __network as network }

import _pbd, * as __pbd from "./pbd"
properties.pbd = { enumerable: true, get: () => _pbd }
export { __pbd as pbd }

import _pif, * as __pif from "./pif"
properties.pif = { enumerable: true, get: () => _pif }
export { __pif as pif }

import _plugin, * as __plugin from "./plugin"
properties.plugin = { enumerable: true, get: () => _plugin }
export { __plugin as plugin }

import _pool, * as __pool from "./pool"
properties.pool = { enumerable: true, get: () => _pool }
export { __pool as pool }

import _remote, * as __remote from "./remote"
properties.remote = { enumerable: true, get: () => _remote }
export { __remote as remote }

import _resourceSet, * as __resourceSet from "./resource-set"
properties.resourceSet = { enumerable: true, get: () => _resourceSet }
export { __resourceSet as resourceSet }

import _role, * as __role from "./role"
properties.role = { enumerable: true, get: () => _role }
export { __role as role }

import _schedule, * as __schedule from "./schedule"
properties.schedule = { enumerable: true, get: () => _schedule }
export { __schedule as schedule }

import _scheduler, * as __scheduler from "./scheduler"
properties.scheduler = { enumerable: true, get: () => _scheduler }
export { __scheduler as scheduler }

import _server, * as __server from "./server"
properties.server = { enumerable: true, get: () => _server }
export { __server as server }

import _session, * as __session from "./session"
properties.session = { enumerable: true, get: () => _session }
export { __session as session }

import _sr, * as __sr from "./sr"
properties.sr = { enumerable: true, get: () => _sr }
export { __sr as sr }

import _system, * as __system from "./system"
properties.system = { enumerable: true, get: () => _system }
export { __system as system }

import _tag, * as __tag from "./tag"
properties.tag = { enumerable: true, get: () => _tag }
export { __tag as tag }

import _task, * as __task from "./task"
properties.task = { enumerable: true, get: () => _task }
export { __task as task }

import _test, * as __test from "./test"
properties.test = { enumerable: true, get: () => _test }
export { __test as test }

import _token, * as __token from "./token"
properties.token = { enumerable: true, get: () => _token }
export { __token as token }

import _user, * as __user from "./user"
properties.user = { enumerable: true, get: () => _user }
export { __user as user }

import _vbd, * as __vbd from "./vbd"
properties.vbd = { enumerable: true, get: () => _vbd }
export { __vbd as vbd }

import _vdi, * as __vdi from "./vdi"
properties.vdi = { enumerable: true, get: () => _vdi }
export { __vdi as vdi }

import _vif, * as __vif from "./vif"
properties.vif = { enumerable: true, get: () => _vif }
export { __vif as vif }

import _vm, * as __vm from "./vm"
properties.vm = { enumerable: true, get: () => _vm }
export { __vm as vm }

import _xo, * as __xo from "./xo"
properties.xo = { enumerable: true, get: () => _xo }
export { __xo as xo }

import _xosan, * as __xosan from "./xosan"
properties.xosan = { enumerable: true, get: () => _xosan }
export { __xosan as xosan }

export default Object.create(null, properties)
